// src/apis/apiServices/documentCategory.js
import axios from "../axiosInstance";

// IMPORTANT: use the exact path/casing your backend exposes (Swagger).
// You had `"/DocumentCategory"` earlier — keep that if Swagger shows that.
const prefix = "/DocumentCategory";

const getDocumentCategoryList = async () => {
  //console.log("[documentCategoryService] GET", `${prefix}/getDocumentCategoryList`);
  try {
    const response = await axios.get(`${prefix}/getDocumentCategoryList`);
    console.log("[documentCategoryService] getDocumentCategoryList response:", response?.status, response?.data);
    return response?.data;
  } catch (error) {
    console.error("[documentCategoryService] getDocumentCategoryList error:", error?.response ?? error);
    // rethrow so caller can decide how to show UI
    throw error;
  }
};

const getDocumentCategoryById = async (id) => {
  //console.log("[documentCategoryService] GET", `${prefix}/getDocumentCategoryById/${id}`);
  try {
    const response = await axios.get(`${prefix}/getDocumentCategoryById/${id}`);
    return response?.data;
  } catch (error) {
    console.error("[documentCategoryService] getDocumentCategoryById error:", error?.response ?? error);
    throw error;
  }
};

const addDocumentCategory = async (payload) => {
 // console.log("[documentCategoryService] POST", `${prefix}/createDocumentCategory`, payload);
  try {
    const response = await axios.post(`${prefix}/createDocumentCategory`, payload);
    console.log("[documentCategoryService] addDocumentCategory response:", response?.status, response?.data);
    return response?.data;
  } catch (error) {
    console.error("[documentCategoryService] addDocumentCategory error:", error?.response ?? error);
    throw error;
  }
};

const deleteDocumentCategory = async (id) => {
 // console.log("[documentCategoryService] DELETE", `${prefix}/deleteDocumentCategory/${id}`);
  try {
    const response = await axios.delete(`${prefix}/deleteDocumentCategory/${id}`);
    // Some backends return 204 No Content (response.data === undefined)
    // Normalize to an object the component can inspect.
    if (response?.status === 204) {
      return { isSuccess: true, message: "Deleted", status: 204 };
    }
    // Otherwise return response data (ApiResponse wrapper or similar)
    return response?.data ?? { isSuccess: true, message: "Deleted", status: response?.status };
  } catch (error) {
    console.error("[documentCategoryService] deleteDocumentCategory error:", error?.response ?? error);
    // Rethrow so the component's catch can show a proper message
    throw error;
  }
};

export const documentCategoryService = {
  getDocumentCategoryList,
  getDocumentCategoryById,
  addDocumentCategory,
  deleteDocumentCategory,
};

export default documentCategoryService;
